import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { InquiryForm } from './InquiryForm';

export const InquiryModal = ({ isOpen, onClose, preselectedSolution = '', source = 'website' }) => {
  const [submitted, setSubmitted] = useState(false);
  const [openCount, setOpenCount] = useState(0);

  useEffect(() => {
    if (!isOpen) return undefined;
    // A new key per opening gives a fresh, empty form each time.
    setOpenCount((n) => n + 1);
    setSubmitted(false);
    document.body.style.overflow = 'hidden';
    const onKey = (e) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-start sm:items-center justify-center p-4 bg-slate-950/70 backdrop-blur-xs overflow-y-auto"
      onMouseDown={(e) => e.target === e.currentTarget && onClose()}
    >
      <div
        className="fi-pop relative w-full max-w-lg bg-white rounded-3xl shadow-2xl border border-slate-200 overflow-hidden my-8"
        role="dialog"
        aria-modal="true"
        aria-labelledby="inquiry-title"
      >
        <div className="p-6 bg-gradient-to-r from-[#0c2e6b] to-[#124294] text-white flex items-start justify-between gap-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="text-[10px] font-black uppercase tracking-wider bg-white/20 text-white px-2 py-0.5 rounded-full">
                Quick Enquiry
              </span>
              <span className="text-[11px] text-emerald-300 font-bold flex items-center gap-1.5">
                <span className="relative flex w-2 h-2">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
                  <span className="relative inline-flex w-2 h-2 rounded-full bg-emerald-400" />
                </span>
                <span>Hyderabad desk online</span>
              </span>
            </div>
            <h3 id="inquiry-title" className="text-xl font-black mt-1.5">
              {submitted ? 'Request received' : 'Tell us what you need'}
            </h3>
            <p className="text-xs text-slate-200 mt-0.5">
              {submitted
                ? 'Our team will call you back shortly.'
                : 'Takes under a minute. Our team calls you back within one working day.'}
            </p>
          </div>

          <button
            onClick={onClose}
            className="text-white/80 hover:text-white p-2 rounded-xl hover:bg-white/10 transition-colors cursor-pointer shrink-0"
            aria-label="Close"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="p-6">
          <InquiryForm
            key={openCount}
            preselectedSolution={preselectedSolution}
            source={source}
            onSubmitted={() => setSubmitted(true)}
            onDone={onClose}
          />
        </div>
      </div>
    </div>
  );
};
